import React, { useState, useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { NavbarsAvatar } from "../../components/NavbarsAvatar";
import { ShowDateToUser } from "../../components/ShowDateToUser";
import addDaysToDate from "../../helpers/AddDaysToDate";
import { fetchAxiosToken } from "../../helpers/fetchAxiosToken";
import { useAppSelector } from "../../hooks/hooks";
import { ModalLogin } from "../ModalLogin";
import { async } from "q";
import { useDispatch } from "react-redux";
import { fetchAxiosNoToken } from "../../helpers/fetchAxiosNoToken";
import { set_landing_house } from "../../redux/reducers/landingReducer";
import { MercadoPago } from "../mercadoPago/MercadoPago";
import { formatearNumero } from "../../components/helpers/formatearNumero";
import NiubizPayButton from "pages/dashboardHotel/checkout/NiubizPayButton";
import {
    DOC_EXTRANJERO_SIN_IGV,
    DOC_OPCIONES_FACTURA,
    FacturacionForm,
} from "pages/dashboardHotel/checkout/facturacion_form.types";
import { ModalDatosComprobante } from "pages/dashboardHotel/checkout/ModalDatosComprobante";

interface PedidoAdicional {
    id: number;
    id_pedido: number;
    servicio: string;
    costo: string;
}

interface Pedido {
    id: number;
    costo_alquiler: string;
    costo_total: string;
    pedidos_servicios_adicionales: PedidoAdicional[];
    costo_servicios_adicionales: string;
    descuento_estadia: string;
    estado: string;
    fecha_inicio: string;
    fecha_final: string;
    tipo_moneda: string;
    pagado: string;
    saldo: string;
    casa: Casa;
    id_cliente: number;
    oferta: string;
    garantia: string;
    tipo_garantia: string;
    descuento_cupon: string;
}
export interface Casa {
    nombre: string;
    banner: string;
    Propietario: Propietario;
}

export interface Propietario {
    nombre: string;
    apellido: string;
    correo: string;
    avatar: string;
    banco: string;
    tipo_cuenta: string;
    tipo_moneda: string;
    titular_cuenta: string;
    tipo_documento: string;
    numero_documento: string;
    numero_cuenta: string;
    cci: string;
}

export const CheckoutPago = () => {
    const dispatch = useDispatch();

    const { id, tipo_usuario } = useAppSelector(
        (state) => state.usuario_logeado,
    );
    const { house } = useAppSelector((state) => state.landing_house);
    const {
        is_niubiz: corredor_niubiz,
        is_facturacion: is_facturacion_corredor,
    } = useAppSelector((state) => state.corredor);

    const mostrarNiubiz =
        (house.tipo_usuario === 3 && house.is_niubiz) || corredor_niubiz;

    const is_facturacion =
        (house.tipo_usuario === 3 && house.is_facturacion) ||
        is_facturacion_corredor;

    console.log("is_facturacion", is_facturacion);
    const [formaPago, setFormaPago] = useState("Transferencia bancaria");
    const reservaString = localStorage.getItem("reserva");
    const reserva = reservaString ? JSON.parse(reservaString) : "";
    const [modalVisibleLogin, setModalVisibleLogin] = useState(false);
    const [pagoUnico, setPagoUnico] = useState(true);
    const [comprobantePreview, setComprobantePreview] = useState<string | null>(
        null,
    );

    const [niubizRenderKey, setNiubizRenderKey] = useState<number>(Date.now());
    const [showNiubiz, setShowNiubiz] = useState(false);
    const [comprobante, setComprobante] = useState<File | null>(null);
    const { id_reserva } = useParams();
    const navigate = useNavigate();
    const [pedido, setPedido] = useState<Pedido | null>(null);
    const [enviando, setEnviando] = useState(false);
    const form = new FormData();
    const [llavePublica, setLlavePublica] = useState<null | string>(null);
    const [mercadoPago, setMercadoPago] = useState<null | string>(null);

    const [isComprobante, setIsComprobante] = useState(false);
    const [showModalComprobante, setShowModalComprobante] = useState(false);
    const [factData, setFactData] = useState<FacturacionForm | null>(null);

    const regenerateNiubizButton = () => {
        setNiubizRenderKey(Date.now());
    };

    const getHouseFromTenant = async () => {
        try {
            const data = await fetchAxiosNoToken({
                url: `/casa/getOne/dominio`,
            });
            dispatch(set_landing_house(data));
            setLlavePublica(data.llave_publica_mp || null);
            setMercadoPago(data.is_mercado_pago || null);
        } catch (error) {
            console.log(error);
        }
    };

    console.log(pedido);

    useEffect(() => {
        setModalVisibleLogin(tipo_usuario === null);
        const usuario_current = id ? id : 0;
        //dsdsa
        fetchAxiosToken({
            url: `/pedidos/getOne/${id_reserva}/${usuario_current}`,
        }).then(setPedido);
        getHouseFromTenant();
    }, [tipo_usuario, id, id_reserva]);

    const handleComprobante = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!e.target.files || e.target.files.length === 0) {
            return;
        }
        setComprobante(e.target.files[0]);
        const objectUrl = URL.createObjectURL(e.target.files[0]);
        setComprobantePreview(objectUrl);
    };

    const idCliete = () => {
        if (tipo_usuario === 8) {
            return 0;
        } else if (pedido?.oferta === "No") {
            return pedido.id_cliente;
        } else {
            return id;
        }
    };

    const isIgv = useMemo(() => {
        if (!isComprobante || !factData) return false;
        return !DOC_EXTRANJERO_SIN_IGV.includes(
            factData.tipo_documento_identidad,
        );
    }, [isComprobante, factData]);
    const mostrarOpcionComprobante = pedido && pedido.estado !== "Pago Parcial";

    const sendPayment = async () => {
        if (!comprobante) {
            Swal.fire({
                confirmButtonColor: "#029BFC",
                iconColor: "#029BFC",
                title: "Debes adjuntar el comprobante",
                // text: "Te avisaremos cuando la disponibilidad haya sido confirmada, gracias!",
                icon: "warning",
            });
            return;
        }

        if (!pedido) return;

        if (mostrarOpcionComprobante && isComprobante && !factData) {
            Swal.fire({
                confirmButtonColor: "#029BFC",
                iconColor: "#029BFC",
                title: "Faltan datos del comprobante",
                text: "Completa los datos para emitir el comprobante.",
                icon: "warning",
            });
            return;
        }

        if (
            factData &&
            factData.tipo_comprobante === "Factura" &&
            isComprobante &&
            !DOC_OPCIONES_FACTURA.find(
                (o) => o.value === factData.tipo_documento_identidad,
            )
        ) {
            Swal.fire({
                confirmButtonColor: "#029BFC",
                iconColor: "#029BFC",
                title: "Error en el tipo de documento",
                text: "El tipo de documento seleccionado no es válido para emitir una factura.",
                icon: "error",
            });
            return;
        }
        setEnviando(true);
        form.append("id_pedidos", `${id_reserva}`);
        form.append("id_cliente", `${idCliete()}`);

        form.append(
            "monto",
            `${
                pedido?.estado === "Pago Parcial"
                    ? pedido?.saldo
                    : pagoUnico
                      ? pedido?.costo_total
                      : Number(pedido?.costo_alquiler) / 2
            }`,
        );
        form.append(
            "etapa_pago",
            `${pagoUnico ? "Pago Completo" : "Pago Parcial"}`,
        );
        form.append("pago_pedido", comprobante);

        const data = await fetchAxiosToken({
            url: `/pedidos_pagos`,
            method: `post`,
            body: form,
        });
        console.log(data);
        setEnviando(false);

        navigate("/comprobante-en-revicion");
    };

    if (!pedido)
        return (
            <>
                <div className="fixed top-0 left-0 right-0 flex items-center justify-between p-3 font-medium text-center border shadow-md px-14 md:px-5">
                    <button
                        onClick={() => navigate("/")}
                        className="hover:underline"
                    >
                        Regresar al home
                    </button>
                    <NavbarsAvatar />
                </div>
                <div className="p-4 font-medium">Cargando pedido...</div>
            </>
        );

    return (
        <div>
            {modalVisibleLogin && (
                <ModalLogin
                    modalVisibleLogin={modalVisibleLogin}
                    setModalVisibleLogin={setModalVisibleLogin}
                />
            )}
            {
                <ModalDatosComprobante
                    visible={showModalComprobante}
                    onClose={() => {
                        setShowModalComprobante(false);
                        if (!factData) setIsComprobante(false);
                    }}
                    initial={factData ?? undefined}
                    onSave={(data: any) => {
                        setFactData(data);
                        setIsComprobante(true);
                        setShowModalComprobante(false);
                        regenerateNiubizButton();
                    }}
                />
            }
            <div className="flex items-center justify-between p-3 font-medium text-center border shadow-md px-14 md:px-5">
                <button
                    onClick={() => navigate("/")}
                    className="hover:underline"
                >
                    Regresar al home
                </button>
                <NavbarsAvatar />
            </div>
            <div className="flex items-center justify-center p-3 font-medium text-center px-14 md:px-5">
                <p className="mt-4 text-2xl uppercase 2xl:text-4xl">
                    Pagar reserva
                </p>
            </div>
            <div className="grid w-full gap-10 p-4 mx-auto mt-3 2xl:mt-10 sm:grid-cols-2 max-w-7xl">
                {!showNiubiz ? (
                    <div className="w-full p-4 text-sm border-2 rounded-lg 2xl:text-base">
                        <input
                            type="radio"
                            checked={pagoUnico}
                            onChange={() => setPagoUnico(true)}
                        ></input>
                        <span className="ml-3 font-semibold">Pago unico:</span>
                        <p>Realiza el pago total de tu reserva.</p>
                        <hr className="my-5 border-t-2 border-gray-300" />
                        <div
                            className={
                                pedido.estado === "Pago Parcial" ? "hidden" : ""
                            }
                        >
                            <input
                                type="radio"
                                checked={!pagoUnico}
                                onChange={() => setPagoUnico(false)}
                            ></input>
                            <span className="ml-3 font-semibold">
                                Pago en dos partes:
                            </span>

                            <p>
                                Realiza ahora el pago de la mitad del aquiler
                                que representa{" "}
                                <span className="font-medium">
                                    {formatearNumero(
                                        (Number(pedido?.costo_alquiler) -
                                            Number(pedido?.descuento_cupon)) /
                                            2,
                                    )}{" "}
                                    {pedido.tipo_moneda}
                                </span>{" "}
                                y 7 días antes del check in (
                                <span className="font-medium">
                                    {" "}
                                    {pedido.fecha_inicio
                                        .split("-")
                                        .reverse()
                                        .join("-")}
                                </span>
                                ) realiza el pago pendiente junto con la
                                garantía y servicios adicionales.
                            </p>
                        </div>
                        {mostrarOpcionComprobante && is_facturacion && (
                            <>
                                <hr className="my-5 border-t-2 border-gray-300" />
                                <label className="flex items-center gap-3">
                                    <input
                                        type="checkbox"
                                        checked={isComprobante}
                                        onChange={(e) => {
                                            if (e.target.checked)
                                                setShowModalComprobante(true);
                                            else {
                                                setIsComprobante(false);
                                                setFactData(null);
                                            }
                                        }}
                                    />
                                    <span className="font-semibold">
                                        Solicitar comprobante (Factura/Boleta)
                                    </span>
                                </label>
                                {isComprobante && factData && (
                                    <p className="mt-1 text-xs text-gray-600">
                                        {factData.tipo_comprobante} · Doc:{" "}
                                        {factData.tipo_documento_identidad} ·{" "}
                                        {factData.numero_documento_identidad}{" "}
                                        {isIgv ? "· IGV 18%" : "· Sin IGV"}
                                    </p>
                                )}
                            </>
                        )}
                    </div>
                ) : (
                    <div className="flex flex-col justify-between h-full text-sm text-gray-600">
                        <div className="flex flex-col gap-2">
                            <p className="mb-2 text-base font-semibold text-black">
                                Estás por pagar con tarjeta (Niubiz)
                            </p>

                            <p>
                                <span className="font-semibold">
                                    Tipo de pago:
                                </span>{" "}
                                {pagoUnico
                                    ? "Pago único"
                                    : `Pago en dos partes (50%)`}
                            </p>

                            <p>
                                <span className="font-semibold">
                                    Monto a pagar:
                                </span>{" "}
                                {formatearNumero(
                                    Number(
                                        pedido?.estado === "Pago Parcial"
                                            ? pedido?.saldo
                                            : pagoUnico
                                              ? pedido?.costo_total
                                              : Number(pedido?.costo_alquiler) /
                                                2,
                                    ),
                                )}{" "}
                                {pedido.tipo_moneda}
                            </p>
                        </div>

                        <button
                            type="button"
                            className="mt-4 text-sm text-blue-600 underline"
                            onClick={() => {
                                window.location.reload(); // fuerza recarga completa para evitar bugs
                            }}
                        >
                            Volver atrás o cambiar opciones de pago
                        </button>
                    </div>
                )}

                <div className="flex flex-col w-full p-4 text-sm border-2 rounded-lg 2xl:text-base">
                    <div className="text-base ">
                        Tu pedido para
                        <span className="mx-1 font-medium">
                            {pedido.casa.nombre}.
                        </span>
                    </div>
                    <span>
                        Desde el{" "}
                        <span className="font-medium">
                            {" "}
                            {pedido.fecha_inicio.split("-").reverse().join("-")}
                        </span>
                        , hasta el{" "}
                        <span className="font-medium">
                            {" "}
                            {pedido.fecha_final.split("-").reverse().join("-")}
                        </span>
                        .
                    </span>
                    <div className="flex flex-col gap-2">
                        <div className="flex justify-between mt-4">
                            <span className="font-medium">Precio alquiler</span>
                            <span className="font-medium">
                                {formatearNumero(Number(pedido.costo_alquiler))}{" "}
                                {pedido.tipo_moneda}
                            </span>
                        </div>
                        {Number(pedido.descuento_cupon) > 0 ? (
                            <>
                                <div className="flex justify-between">
                                    <span className="text-green-500">
                                        Descuento por cupon
                                    </span>
                                    <span className="font-medium text-green-600">
                                        -{" "}
                                        {formatearNumero(
                                            Number(pedido.descuento_cupon),
                                        )}{" "}
                                        {pedido.tipo_moneda}
                                    </span>
                                </div>
                                <hr className="my-1" />
                            </>
                        ) : null}
                        <div className="flex justify-between mt-4">
                            <span className="font-medium">Garantia</span>
                            <span className="font-medium">
                                {formatearNumero(Number(pedido.garantia))}{" "}
                                {pedido.tipo_moneda}
                            </span>
                        </div>
                        <hr className="my-1" />
                        {Number(pedido.descuento_estadia) > 0 ? (
                            <>
                                <div className="flex justify-between">
                                    <span className="text-green-600">
                                        Descuento por larga estadía
                                    </span>
                                    <span className="font-medium text-green-600">
                                        -{" "}
                                        {formatearNumero(
                                            Number(pedido.descuento_estadia),
                                        )}{" "}
                                        {pedido.tipo_moneda}
                                    </span>
                                </div>
                                <hr className="my-1" />
                            </>
                        ) : null}
                        {pedido.pedidos_servicios_adicionales.length > 0 ? (
                            <>
                                <span className="font-medium">
                                    Servicios adicionales
                                </span>
                                {pedido.pedidos_servicios_adicionales.map(
                                    (servicio: any) => (
                                        <div
                                            key={servicio.id}
                                            className="flex justify-between"
                                        >
                                            <span className="">
                                                {servicio.servicio}
                                            </span>
                                            <span className="font-medium">
                                                {formatearNumero(
                                                    Number(servicio.costo),
                                                )}{" "}
                                                {pedido.tipo_moneda}
                                            </span>
                                        </div>
                                    ),
                                )}
                                <hr className="my-1" />
                            </>
                        ) : null}
                    </div>
                    <div className="flex justify-between mt-4">
                        <span className="font-medium">
                            Precio total de la reserva
                        </span>
                        <span className="font-medium">
                            {formatearNumero(Number(pedido.costo_total))}{" "}
                            {pedido.tipo_moneda}
                        </span>
                    </div>
                </div>
                <div className="w-full p-3 border-2 rounded-lg 2xl:p-4">
                    {!showNiubiz && (
                        <select
                            onChange={(e) => {
                                setFormaPago(e.target.value);
                                regenerateNiubizButton();
                                if (e.target.value === "Pago electrónico") {
                                    setShowNiubiz(true);
                                } else {
                                    setShowNiubiz(false);
                                }
                            }}
                            value={formaPago}
                            className="bg-slate-100 2xl:mt-7 mt-3 2xl:p-3 p-2 max-w-[500px] w-full border-gray-200 border rounded-md disabled:cursor-not-allowed"
                        >
                            <option
                                className="p-10"
                                value="Transferencia bancaria"
                            >
                                Transferencia bancaria
                            </option>

                            {/* Esta es la nueva validación dinámica */}
                            {mostrarNiubiz && (
                                <option
                                    className="p-10"
                                    value="Pago electrónico"
                                >
                                    Pago electrónico (Niubiz)
                                </option>
                            )}

                            {house.plan > 1 && mercadoPago === "Si" && (
                                <option className="p-10" value="mercado">
                                    Tarjeta de crédito o débito
                                </option>
                            )}
                        </select>
                    )}

                    {formaPago === "Transferencia bancaria" ? (
                        <div className="text-sm 2xl:text-base">
                            <p className="mt-5 text-justify">
                                Realiza tu pago directamente en nuestra cuenta
                                bancaria.{" "}
                                <span className="font-semibold">
                                    Por favor, usa el número del pedido como
                                    referencia de pago.
                                </span>{" "}
                                Tu pedido no se procesará hasta que se haya
                                recibido el importe en nuestra cuenta.
                            </p>
                            <p className="mt-3 font-semibold">
                                Numero de pedido : {id_reserva}
                            </p>
                            <div>
                                <div className="flex flex-row">
                                    <p className="font-semibold">Banco:</p>{" "}
                                    <p className="ml-3">
                                        {pedido.casa.Propietario.banco}
                                    </p>
                                </div>
                                <div className="flex flex-row">
                                    <p className="font-semibold">
                                        Tipo de cuenta:
                                    </p>{" "}
                                    <p className="ml-3">
                                        {pedido.casa.Propietario.tipo_cuenta}
                                    </p>
                                </div>
                                <div className="flex flex-row">
                                    <p className="font-semibold">
                                        Cuenta en{" "}
                                        {pedido.casa.Propietario.tipo_moneda}:
                                    </p>{" "}
                                    <p className="ml-3">
                                        {pedido.casa.Propietario.numero_cuenta}
                                    </p>
                                </div>
                                <div className="flex flex-row">
                                    <p className="font-semibold">CCI:</p>{" "}
                                    <p className="ml-3">
                                        {pedido.casa.Propietario.cci}
                                    </p>
                                </div>
                                <div className="flex flex-row">
                                    <p className="font-semibold">
                                        Titular de cuenta:
                                    </p>{" "}
                                    <p className="ml-3">
                                        {pedido.casa.Propietario.titular_cuenta}
                                    </p>
                                </div>
                            </div>

                            <hr className="my-5 border-t-2 border-gray-300" />
                            <h1 className="mt-4 font-semibold">
                                Por favor, adjuntar su comprobante en formato
                                Imagen
                            </h1>

                            <div className="relative flex mx-auto mt-4 bg-white border-4 border-dashed rounded-lg w-72 h-72 ">
                                {comprobantePreview ? (
                                    <div className="w-full h-full rounded-lg ">
                                        <img
                                            className="object-cover w-full h-full rounded-lg"
                                            src={comprobantePreview}
                                            alt="Comprobante de pago"
                                        />
                                    </div>
                                ) : (
                                    <div className="flex items-center justify-center p-3 ">
                                        <div className="flex flex-col items-center justify-center w-full mx-auto ">
                                            <div className="relative flex flex-col items-center justify-center">
                                                <span className="mt-2 font-bold text-center ">
                                                    Arrastre el comprobante
                                                </span>
                                                o
                                                <span
                                                    className={`text-center text-blue-500  font-normal`}
                                                >
                                                    Sube la imagen desde tu
                                                    dispositivo
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <input
                                    type="file"
                                    onChange={handleComprobante}
                                    accept="image/*"
                                    className="absolute top-0 left-0 bg-red-200 opacity-0 cursor-pointer w-72 h-72 file:cursor-pointer"
                                />
                            </div>

                            <button
                                disabled={enviando}
                                onClick={() => sendPayment()}
                                className="flex justify-center w-full max-w-xs p-2 mx-auto mt-4 border-2 rounded-lg hover:bg-slate-100 hover:scale-105 disabled:bg-slate-100"
                            >
                                {enviando ? "Enviando.." : "Enviar Comprobante"}
                            </button>
                        </div>
                    ) : formaPago === "Pago electrónico" ? (
                        // ==== BLOQUE NIUBIZ ====
                        <div className="flex flex-col items-start justify-start w-full mt-2">
                            <p className="mb-2 text-sm text-slate-600">
                                Paga con tarjeta de crédito/débito de forma
                                segura.
                            </p>

                            {pedido && (
                                <NiubizPayButton
                                    key={niubizRenderKey}
                                    renderKey={`niubiz-${niubizRenderKey}`}
                                    tipo_pedido="Casa"
                                    idReserva={String(id_reserva)}
                                    tipoMoneda={pedido.tipo_moneda}
                                    amount={Number(
                                        pedido?.estado === "Pago Parcial"
                                            ? pedido?.saldo
                                            : pagoUnico
                                              ? pedido?.costo_total
                                              : Number(pedido?.costo_alquiler) /
                                                2,
                                    )}
                                    tipoPago={
                                        pagoUnico
                                            ? "Pago Completo"
                                            : "Pago Parcial"
                                    }
                                    isComprobante={false}
                                    factData={factData}
                                    id_reserva={id_reserva}
                                    onReset={() => {
                                        window.location.reload();
                                    }}
                                />
                            )}

                            <small className="mt-2 text-xs text-slate-500">
                                Al confirmar, verás el modal seguro de Niubiz.
                                Al finalizar, te redireccionaremos
                                automáticamente según el resultado.
                            </small>
                        </div>
                    ) : (
                        <div className="flex flex-col items-center justify-center mt-4">
                            {house?.plan > 1 ? (
                                <p>
                                    Pago con tarjeta de crédito/débito cuenta
                                    con un costo adicional del 5% del monto a
                                    pagar.
                                </p>
                            ) : null}
                            {house.is_mercado_pago === "Si" &&
                                llavePublica !== null && (
                                    <MercadoPago
                                        llavePublica={llavePublica}
                                        tipo_moneda={pedido.tipo_moneda}
                                        costo={Number(
                                            pedido?.estado === "Pago Parcial"
                                                ? pedido?.saldo
                                                : pagoUnico
                                                  ? pedido?.costo_total
                                                  : Number(
                                                        pedido?.costo_alquiler,
                                                    ) / 2,
                                        )}
                                        tipo_pago={`${
                                            pagoUnico
                                                ? "Pago Completo"
                                                : "Pago Parcial"
                                        }`}
                                        id_cliente={idCliete()}
                                    />
                                )}
                        </div>
                    )}
                </div>
                <div className="flex flex-col w-full p-4 text-sm border-2 rounded-lg h-60 2xl:text-base">
                    <div className="text-base font-semibold ">Resumen</div>
                    <div className="flex flex-col gap-2">
                        <div className="flex justify-between mt-4">
                            <span className="font-medium">Pagado</span>
                            <span className="font-medium">
                                <span>
                                    {formatearNumero(Number(pedido.pagado))}
                                </span>{" "}
                                {pedido.tipo_moneda}
                            </span>
                        </div>
                        <hr className="my-1" />
                    </div>

                    <div className="flex flex-col gap-2">
                        <div className="flex justify-between mt-4">
                            <span className="font-medium">Monto a pagar </span>

                            {pedido.estado === "Pago Parcial" ? (
                                <span className="font-medium">
                                    {formatearNumero(Number(pedido.saldo))}{" "}
                                    {pedido.tipo_moneda}
                                </span>
                            ) : pagoUnico ? (
                                <span className="font-medium">
                                    {formatearNumero(
                                        Number(pedido.costo_total),
                                    )}{" "}
                                    {pedido.tipo_moneda}
                                </span>
                            ) : (
                                <span className="font-medium">
                                    {formatearNumero(
                                        Number(pedido?.costo_alquiler) / 2,
                                    )}{" "}
                                    {pedido.tipo_moneda}
                                </span>
                            )}
                        </div>
                        <hr className="my-1" />
                    </div>
                    <div className="flex justify-between mt-4">
                        <span className="font-medium">Saldo pendiente</span>
                        {pagoUnico ? (
                            <span className="font-medium">
                                <span>
                                    {formatearNumero(Number(pedido.saldo))}
                                </span>{" "}
                                {pedido.tipo_moneda}
                            </span>
                        ) : (
                            <span className="font-medium">
                                {formatearNumero(
                                    Number(pedido.costo_total) -
                                        Number(pedido?.costo_alquiler) / 2,
                                )}{" "}
                                {pedido.tipo_moneda}
                            </span>
                        )}
                    </div>
                    <div className="flex justify-between mt-4">
                        {pedido.garantia !== "0.00" &&
                            pedido.tipo_garantia === "Pago al ingreso casa" && (
                                <div className="flex w-full px-1 mt-4 bg-blue-200 border-4 border-blue-300 rounded-lg">
                                    <span className="underline">
                                        Garantía:{" "}
                                    </span>
                                    <span className="ml-2 italic font-thin ">
                                        Deberás pagar{" "}
                                        {formatearNumero(
                                            Number(pedido.garantia),
                                        )}{" "}
                                        {pedido.tipo_moneda} en efectivo al
                                        momento de llegar a la propiedad
                                    </span>
                                </div>
                            )}
                    </div>
                </div>
            </div>
        </div>
    );
};
